import axios from 'axios';

// True when this build is running inside the Shopify admin (served from
// /shopify/app, which loads App Bridge and sets this flag).
export const EMBEDDED = typeof window !== 'undefined' && !!window.__HP_EMBEDDED__;

// API client for pages that also run embedded: inside Shopify there's no
// Google session cookie, so every request carries a fresh App Bridge ID token
// instead (tokens only live a minute, so one is fetched per request).
export const api = axios.create();
if (EMBEDDED) {
  api.interceptors.request.use(async config => {
    const token = await window.shopify.idToken();
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    return config;
  });
}

// Links to Shopify admin pages: open in the admin itself when embedded,
// in a new tab from the internal site.
export const ADMIN_LINK_TARGET = EMBEDDED ? '_top' : '_blank';
